import { render, staticRenderFns } from "./NumberTile.vue?vue&type=template&id=4dec7bfc&"
import script from "./NumberTile.vue?vue&type=script&lang=js&"
export * from "./NumberTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports